import { render } from "./HomeBlockchain.vue?vue&type=template&id=b1478306"
import script from "./HomeBlockchain.vue?vue&type=script&lang=js"
export * from "./HomeBlockchain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__